<template>
  <div class="container">
    <van-tabs scrollspy sticky>
      <van-tab v-for="(group, index) in list" :title="group.group" :key="index" :badge="group.hot ? 'Hot' : ''">
        <div class="item" v-for="(item, index) in group.list" @click="doGet(item)">
          <div class="content coupon" v-if="item.type == 'coupon'">
            <div class="amount">
              <div class="coupon-amount">
                <div class="unit">￥</div>
                <div class="value">{{item.value}}</div>
              </div>
              <div class="coupon-limit">
                {{item.tips}}
              </div>
            </div>
            <div class="tips">{{item.name}}</div>
            <div class="operation">
              <van-button plain type="danger" size="small">立即领取</van-button>
            </div>
          </div>
          <div class="content" v-else>
            <div class="item-name">{{(item.tips || '') + item.name}}</div>
            <img :src="item.logo" alt="" v-if="item.logo">
          </div>
        </div>
      </van-tab>
    </van-tabs>

    <!-- <div class="group" v-for="(group, groupIndex) in list">
      <h2 class="group-name">
        {{group.group}}
      </h2>
      <div class="item" v-for="(item, index) in group.list" @click="doGet(item)">
        <div class="item-name">{{item.name}}</div>
        <img :src="item.logo" alt="" v-if="item.logo">
      </div>
    </div>
    <div class="waiting">
      <img src="../../assets/waiting.png" alt="敬请期待">
      <span>更多优惠敬请期待</span>
    </div> -->
    <!-- <div class="reward" @click="reward">
      打赏
    </div> -->
  </div>
</template>

<script>
import { Tab, Tabs, Button } from 'vant';

import mtwm from '../../assets/mtwm.jpg';
import eleme from '../../assets/eleme.png';
import qcloud from '../../assets/qcloud.png';
import aliyun from '../../assets/aliyun.png';
import huaweiyun from '../../assets/huaweiyun.png';
import qiniuyun from '../../assets/qiniuyun.png';
import ucloud from '../../assets/ucloud.png';
import hongbaoma from '../../assets/hongbaoma.png';
import tm11 from '../../assets/tm11.jpg';

export default {
  data() {
    return {
      list: [
        {
          group: '外卖红包',
          list: [
            {
              'name': '饿了么红包',
              'logo': eleme,
              'router': 'https://s.click.ele.me/SmHV1wu'
            },
            {
              'name': '美团外卖红包',
              'logo': mtwm,
              'router': 'https://click.jutuike.com/mt.php?t=1&u=4683&k=waimai'
            }
          ]
        },
        {
          group: '低价服务器',
          list: [
            {
              'name': '【UCloud】1核1G 云主机 59元/年起',
              'logo': ucloud,
              'router': 'https://www.ucloud.cn/site/active/kuaijie.html?invitation_code=C1xBCEFCF03B9F1'
            },
            {
              'name': '【腾讯云】云服务器1核2G 99元/年',
              'logo': qcloud,
              'router': 'https://url.cn/xI9h6r6Q'
            },
            {
              'name': '【阿里云】ECS云服务器1核2G 96.9元/年起',
              'logo': aliyun,
              'router': 'https://www.aliyun.com/minisite/goods?userCode=rhkz46a1'
            },
            // {
            //   'name': '【七牛云】',
            //   'logo': qiniuyun,
            //   'router': 'https://portal.qiniu.com/qvm/active?code=1380956261wRXiV'
            // },
            {
              'name': '【华为云】1核2G 云耀云服务器 281.46元/年',
              'logo': huaweiyun,
              'router': 'https://activity.huaweicloud.com/discount_area_v5/index.html?fromacct=02a011db-a651-4b4d-94fe-1e0e3ec675a1&utm_source=V1g3MDY4NTY=&utm_medium=cps&utm_campaign=201905'
            },
          ]
        }
      ]
    }
  },
  components: {
    'van-tab': Tab,
    'van-tabs': Tabs,
    'van-button': Button
  },
  methods: {
    doGet(item) {
      const router = item.router;

      var ua = navigator.userAgent.toLowerCase();
      var isWeixin = ua.indexOf('micromessenger') >= 0;
      var isQQ = ua.indexOf('qq') >= 0;
      // 如果从微信、QQ打开
      if (isWeixin || isQQ) {
        // 判断是否打开淘宝相关链接
        let message = item.content;
        if (router.indexOf('taobao.com') >= 0) {
          this.$copyText(message).then(res => {
            alert(item.tips);
          }).catch(err => {
            alert('请点击右上角，选择从浏览器打开');
          })
          return;
        }
      }

      if (item.action == 'copy') {
        let message = item.content;
        this.$copyText(message).then(res => {
          alert(item.tips);
          location.href = router;
        }).catch(err => {
          alert(item.errorTips);
        })
        return;
      }
      if (router.startsWith('/')) {
        this.$router.push(item.router);
      } else {
        location.href = router;
      }
    },
    reward() {
      // location.href='alipays://platformapi/startapp?appId=09999988&actionType=toAccount&goBack=NO&amount=1.00&userId=209027776262&memo=赏你了';
      try {
        location.href = 'alipayqr://platformapi/startapp?saId=10000007&clientVersion=3.7.0.0718&qrcode=https://qr.alipay.com/fkx026115xeikyi0sabnta6';
      } catch(err) {
        this.$copyText('2088702337086592').then(res => {
          alert('账号已复制，打开支付宝向我转账');
          location.href = router;
        }).catch(err => {
        })
      }
    }
  },
  created() {
    document.title = '外卖购物红包助手';
  }
}
</script>

<style lang="less" scoped>
.container {
  .group-name {
    margin: 12px;
    padding: 12px 0 3px;
    border-bottom: 2px solid #ddd;
  }
  .group-name:first-child {
    padding-top: 0;
  }
  .item {
    padding: 12px;
    min-height: 100px;
    margin: 12px 12px 0;
    background: #FFFFFF;
    border-radius: 6px;

    .item-name {
      font-weight: bold;
      padding-bottom: 12px;
    }
    img {
      width: 100%;
      border-radius: 6px;
    }
  }
  .waiting {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 24px;
    border-top: 1px solid #eeeeee;
    padding-top: 24px;

    img {
      width: 48px;
      height: 48px;
    }
    span {
      font-size: 14px;
      color: #666666;
      margin-left: 6px;
    }
  }

  .reward {
    position: fixed;
    z-index: 2;
    top: 50%;
    right: 12px;
    width: 48px;
    height: 48px;
    border-radius: 100px;
    background: #F0F0F0;
    background-image: radial-gradient(#DDDDDD, #FFFFFF);
    box-shadow: 5px 5px 4px #888888;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    cursor: pointer;
  }


.coupon {
  display: flex;
  align-items: center;
}
.amount {
  margin-right: 12px;
  height: 99px;
  width: 109px;
  background: #e24141;
  color: #FFFFFF;
  /* 相对定位，方便让before和after伪元素绝对定位偏移 */
  position: relative;
  /* 把超出div的部分隐藏起来 */
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.amount .coupon-amount {
  display: flex;
  align-items: center;
  justify-content: center;
}
.amount:before {
  content: ' ';
  width: 0;
  height: 100%;
  /* 绝对定位进行偏移 */
  position: absolute;
  top: 5px;
  /* 圆点型的border */
  border-right: 5px dotted white;
  /* 偏移一个半径，让圆点的一半覆盖div */
  left: -2.5px;
}
.amount .unit {
  font-size: 14px;
  margin-right: 3px;
}
.amount .value {
  font-size: 28px;
}
.amount .coupon-limit {
  font-size: 12px;
  font-weight: 300;
  margin-top: 6px;
  color: #FAFAFA;
}
.tips {
  flex: 1;
  font-size: 14px;
  margin-right: 6px;
  color: #333333;
}
}
</style>
